import React from "react";
import { useState, useEffect } from "react";
import Airtable from "airtable";
import base from "./API/airtable";
import Form from "./components/Form";
import Match from "./components/Match";
import GarlandDecorationSection from "./components/GarlandDecorationSection";

const App = () => {
  const [ showForm,     setShowForm ]     = useState(true);
  const [ newUserAdded, setNewUserAdded ] = useState(false);
  const [ formData,     setFormData ]     = useState({
    name: "",
    email: "",
    linkedinURL: "",
    achievement: "",
    expertise: "",
    support: "",
    emailConsent: false
  });

  const [searchTerm,  setSearchTerm] = useState('');
  const [submissions, setSubmissions] = useState([]);

  // Fetch submissions from Airtable on initial load
  useEffect(() => {
    const fetchSubmissions = async () => {
      try {
        const records = await base("users").select({}).all();
        const formattedSubmissions = records.map((record) => ({
          id:          record.id,
          name:        record.fields.name,
          linkedinURL: record.fields.linkedinURL,
          achievement: record.fields.achievement,
          expertise:   record.fields.expertise,
          support:     record.fields.support,

        }));
        setSubmissions(formattedSubmissions);
      } catch (error) {
        console.error("Error fetching submissions:", error);
      }
    };

    fetchSubmissions();
  }, []);


  const handleSubmit = async (e) => {
    try {

      // Airtable connection!
      // CREATE NEW USER
      base("users").create(
        [
          {
            fields: {
              name:        formData.name,
              email:       formData.email,
              linkedinURL: formData.linkedinURL,
              achievement: formData.achievement,
              expertise:   formData.expertise,
              support:     formData.support,
              emailConsent:formData.emailConsent
            },
          },
        ],
        (err, records) => {
          if (err) {
            console.log("Error adding record:", err);
            return;
          }
          console.log("Record added:", records);
          setFormData({
            name: "",
            email: "",
            linkedinURL: "",
            achievement: "",
            expertise: "",
            support: "",
            emailConsent: false
          });
        }
      );
      
      // Add submission to local display
      setSubmissions([...submissions, { ...formData, id: submissions.length + 1 }]);
      setFormData({
        name: "",
        email: "",
        linkedinURL: "",
        achievement: "",
        expertise: "",
        support: "",
        emailConsent: false
      }); 
      setNewUserAdded(true);
      setShowForm(false);
      setNewUserAdded(true);
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const filteredSubmissions = submissions.filter(submission => {
    const searchLower = searchTerm.toLowerCase();
    const expertise = submission.expertise ? submission.expertise.toLowerCase() : '';
    const seeking = submission.seeking ? submission.seeking.toLowerCase() : '';
    return expertise.includes(searchLower) || seeking.includes(searchLower);
  });

  const findMatches = (submission) => {
    const expertise = submission.expertise ? submission.expertise.toLowerCase() : '';
    const seeking = submission.seeking ? submission.seeking.toLowerCase() : '';
    
    return submissions.filter(s => {
      const sExpertise = s.expertise ? s.expertise.toLowerCase() : '';
      const sSeeking = s.seeking ? s.seeking.toLowerCase() : '';
      return s.id !== submission.id && (
        sExpertise.includes(seeking) || sSeeking.includes(expertise)
      );
    });
  };


  return (
    <div id="garland-app" className="max-w-4xl mx-auto space-y-8 p-4 font-raleway">

      {/* Form app */}
      <Form 
        formData={formData}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
        setShowForm={setShowForm}
        newUserAdded={newUserAdded}
        setNewUserAdded={setNewUserAdded}
      />

      {/* Garland Decoration */}
      {/* <div className="relative mb-8">
        <GarlandDecorationSection />
      </div>  */}

      {/* Match app */}
      <Match 
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      filteredSubmissions={filteredSubmissions}
      findMatches={findMatches}
      showForm={showForm}
      newUserAdded={newUserAdded}
      />
    </div>
  );
};

export default App;